<template>
    <modal
        :name="'editarPrecio-' + localPrecio.id"
        transition="pop-out"
        :width="800"
        height="auto"
        scrollable
    >
        <div class="card m-0">
            <div class="card-header">
                <div class="row">
                    <div class="col-10">
                        <h2>Editar tipo de abono - {{ localPrecio.descripcion }}</h2>
                    </div>
                    <div class="col-2">
                        <button type="button" class="close" @click.prevent="close(false)">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <FormPrecio :tipo="localPrecio" v-on:terminado="editarPrecio()"/>
            </div>
            <div class="card-footer text-right">
                <Button type="button" name="button" @click.prevent="close(false)">CERRAR</Button>
            </div>
        </div>
    </modal>
</template>

<script>

    import FormPrecio from './con-recinto/FormPrecio';

    export default {
        props: ['lista_id', 'precio'],
        data() {
            return {
                loading: false,
                localPrecio: { ...this.precio }
            }
        },
        methods: {
            close(creado) {
                this.$emit('close', 'editarPrecio-' + this.localPrecio.id, creado);
            },
            editarPrecio() {
                this.loading = true;

                this.localPrecio.filters = {};
                this.localPrecio.lista_id = this.lista_id;
                this.localPrecio.precio_id = this.precio.id;

                if(this.localPrecio.activo) {
                    this.localPrecio.activo = 1;
                } else {
                    this.localPrecio.activo = 0;
                }

                this.$store.dispatch(this.config.getVuexAlias('back.precios.editar'), this.localPrecio).then(res => {
                    this.$toast.success(res.data.message);
                    this.close(true);
                }).finally(() => this.loading = false);
            }
        },
        components: {
            FormPrecio
        }
    }
</script>
